<div style="min-width: 400px;">
    <forge-scaffold>
        <div slot="body" class="dialog-content" style="max-height: 75vh;">
            <div class="layout-row layout-align-space-around" *ngIf="showBusyIndicator">
                <busy-indicator></busy-indicator>
            </div>

            <form #form="ngForm">
                <metadata-view [ngModelGroup]="modelGroupName" [viewTitle]="title" [view]="view" [model]="model"
                               [datacontroller]="datacontroller" [viewOnly]="action.ViewOnly" [onDelete]="onDelete"
                               [(recalculating)]="viewRecalculating" [pageHeader]="false" [dialogIndex]="dialogIndex">
                </metadata-view>
            </form>
        </div>

        <forge-toolbar slot="footer" class="layout-row layout-align-end">
            <command-bar [commands]="commands" telemetry="title" slot="end"></command-bar>
        </forge-toolbar>
    </forge-scaffold>
</div>
